export class ReportSource{
  SOURCE_CODE: string;
  SOURCE_NAME: string;

  constructor(SOURCE_CODE: string, SOURCE_NAME: string){
    this.SOURCE_CODE = SOURCE_CODE;
    this.SOURCE_NAME = SOURCE_NAME;
  }
}

export class SourceValue {
  TYPE: string;
  NOTE: string;
  SOURCE_TITLE?: string;

  constructor(TYPE: string, NOTE: string, SOURCE_TITLE?: string){
    this.TYPE = TYPE;
    this.NOTE = NOTE;
    this.SOURCE_TITLE = SOURCE_TITLE;
  }
}
